import axios from 'axios';

/**
 * Asignar la clave de al Api a la cabecera.
 * @param {string} apiKey 
 */
export const setApiKeyAzureAxios = apiKey =>
{
    if (apiKey)

        axios.defaults.headers.common['api-key-v1'] = apiKey;

    else

        delete axios.defaults.headers.common['api-key-v1'];
};

/**
 * Asignar el token de acceso a la cabecera.
 * @param {string} token 
 */
export const setAuthorizationTokenAzure = token =>
{
    if (token)

        axios.defaults.headers.common['authorization-token-v1'] = token;

    else

        delete axios.defaults.headers.common['authorization-token-v1'];
};